export const module = {
  info: {
    name: 'jikatel-cli-destination',
    caption: 'Jikatel CLI Destination'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel CLI Destination',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-cli-destination',
    children: [
      {
        caption: 'Create CLI Destination',
        icon: 'el-icon-plus',
        routeName: 'module->jikatel-cli-destination->create'
      },
      {
        caption: 'List CLI Destinations',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-cli-destination->list'
      }
    ]
  }
}

export default module
